import React from "react";
import * as Icons from "lucide-react";

export const CategoryIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = Icons[name] || Icons.Compass;
  return <Icon className={className} />;
};
